const routes = [
  {
    path: '/tukar-voucher',
    name: 'Tukar Voucher',
    meta: {
      title: 'Tukar Voucher'
    },
    component: () => import(/* webpackChunkName: 'tukarVoucher' */ '../views/payment/RedeemVoucherV2FlowRedeem.vue')
  },
  {
    path: '/payment/thankyou/:id',
    name: 'payment-thankyou-page',
    props: true,
    meta: {
      title: 'Proses Pembayaran'
    },
    component: () => import(/* webpackChunkName: 'thankyouPage' */ '../views/payment/ThankyouPage.vue')
  },
  {
    path: '/payment/status/:id',
    name: 'PaymentStatus',
    meta: {
      title: 'Status Pembayaran'
    },
    component: () => import(/* webpackChunkName: 'paymentStatus' */ '../views/payment/PaymentStatus.vue')
  },
  {
    path: '/daftar-pilihan',
    name: 'Daftar Pilihan',
    meta: {
      title: 'Daftar Pilihan'
    },
    component: () => import(/* webpackChunkName: 'keranjang' */ '../views/payment/ShoppingCart.vue')
  },
  {
    path: '/checkout',
    name: 'Checkout',
    meta: {
      title: 'Checkout',
      layout: 'checkout'
    },
    component: () => import(/* webpackChunkName: 'checkout' */ '../views/payment/CheckoutPage.vue')
  },
  {
    path: '/payment/hosted/:type',
    name: 'Payment',
    meta: {
      title: 'Payment'
    },
    component: () => import(/* webpackChunkName: 'Pembayaran' */ '../views/payment/HostedPaymentBase.vue')
  },
  {
    path: '/daftar-transaksi',
    name: 'Daftar Transaksi',
    meta: {
      title: 'Daftar Transaksi Pembelian | Karier.mu'
    },
    component: () => import(/* webpackChunkName: "riwayat" */ '../views/payment/PaymentHistory.vue')
  },
  {
    path: '/detail-pembelian/:id',
    name: 'PaymentDetail',
    meta: {
      title: 'Detail Pembelian'
    },
    component: () => import(/* webpackChunkName: "detailpembelian" */ '../views/payment/PaymentDetail.vue')
  }
]

export default routes
